import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material'
import { OptimizerEvents, OptimizerEvent } from '../types/ports'
import { TimeString } from '../types/models'
import { DateTime, Interval } from 'luxon'
import { Trans, useTranslation } from 'react-i18next'
import { useState } from 'react'
import { lang } from '../utils/lang'

function EventLine(props: { time: TimeString, command: OptimizerEvent, display: 'none' | 'block' }) {
  const { time, command, display } = props
  const theme = useTheme()
  const { t } = useTranslation()

  const color = theme.palette.primary.main
  const stamp = DateTime.fromISO(time).toLocal()
  const state = t(`State-${command.state.replace('BATTERY_OPTIMIZER_STATE_', '')}`)

  const time1 = DateTime.fromISO(time)
  const time2 = DateTime.now()
  const diff = Interval.fromDateTimes(time1, time2).length('days')
  const useFullDate = diff < -7 || diff > 7
  const day = (useFullDate ? lang.dateFromStamp(stamp.toMillis()) : lang.dayNameShort(stamp.weekday)) + ' ' + stamp.toFormat('HH:mm')

  const { reserve_dn, reserve_up } = command
  const downSymbols = {
    BATOPT_EVENT_RESERVE_UNKNOWN: '',
    BATOPT_EVENT_RESERVE_NO: '',
    BATOPT_EVENT_RESERVE_PARTIAL: '▽',
    BATOPT_EVENT_RESERVE_FULL: '▼',
  }
  const upSymbols = {
    BATOPT_EVENT_RESERVE_UNKNOWN: '',
    BATOPT_EVENT_RESERVE_NO: '',
    BATOPT_EVENT_RESERVE_PARTIAL: '△',
    BATOPT_EVENT_RESERVE_FULL: '▲',
  }

  return <>
    <Box sx={{ display, color }} component="span">{day}</Box>
    <Box sx={{ display, color }} component="span">{state}</Box>
    <Box>{upSymbols[reserve_up]} {downSymbols[reserve_dn]}</Box>
  </>
}

export interface BatteryScheduleProps {
  events: OptimizerEvents
  sx?: SxProps<Theme>
}

export function BatterySchedule(props: BatteryScheduleProps): React.ReactElement {

  const [all, setAll] = useState(false)

  const { events, sx } = props
  const MORE_LIMIT = 4

  if (events.length === 0) {
    return <Box sx={sx}><Trans>No plan</Trans></Box>
  }

  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: '2fr 3fr 1fr',
      ...sx
    }}>
      {events.map((e, idx) => <EventLine key={idx} display={!all && idx >= MORE_LIMIT ? 'none' : 'block' } time={e[0]} command={e[1]}/>)}
      {!all && events.length > MORE_LIMIT && <Typography sx={{ cursor: 'pointer' }} onClick={() => setAll(true)}><Trans>(more)</Trans></Typography>}
    </Box>
  )
}
